import React from 'react';
import { Button } from 'shards-react';
import { RootState, useDispatch, useSelector } from '../../../redux/store';
import { setDialogMode, openDialog, selectOrganizationBase } from '../../../redux/slices/organizationBase';
import { useTranslation } from 'react-i18next';
import { EDIT_ACTION } from '../../../constants';

const AddOrganizationBase = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  /**
   * 組織名の新規作成
   */
  const handleAddOrganizationBase = (): void => {
    dispatch(selectOrganizationBase());
    dispatch(setDialogMode(EDIT_ACTION.CREATE));
    dispatch(openDialog());
  };

  // VIEW
  // ================================================================================

  return (
    <Button className="mr-2" theme="white" onClick={handleAddOrganizationBase}>
      <i className="material-icons">add</i>
      {t('organizationBase.add')}
    </Button>
  );
};

export default AddOrganizationBase;
